import TileGridV2 from './TileGrid.v2'

export default TileGridV2
// eslint-disable-next-line import/export
export * from './TileGrid.v2'
